import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
    user: any;
    accessToken: string | null;
    refreshToken: string | null;
    isAuthenticated: boolean;
    setAuth: (user: any, accessToken: string, refreshToken: string) => void;
    setTokens: (accessToken: string, refreshToken: string) => void;
    logout: () => void;
}

const useAuthStore = create<AuthState>()(
    persist(
        (set) => ({
            user: null,
            accessToken: null,
            refreshToken: null,
            isAuthenticated: false,
            
            setAuth: (user, accessToken, refreshToken) => set({
                user,
                accessToken,
                refreshToken,
                isAuthenticated: true
            }),
            
            setTokens: (accessToken, refreshToken) => set({
                accessToken,
                refreshToken
            }),
            
            logout: () => set({
                user: null,
                accessToken: null,
                refreshToken: null,
                isAuthenticated: false
            })
        }),
        {
            name: 'hopfitness-auth-storage', // Stocké dans le localStorage
        }
    )
);

export default useAuthStore;
